import moment from 'moment';
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';
import HeaderAndDays from './HeaderAndDays';
import { convertStringToBoolean } from '../../../utils/CommonUtils';

class OperationTimeScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preparationTime: {
                id: null,
                fromHour: null,
                fromMinute: null,
                toHour: null,
                toMinute: null,
                validOnMonday: false,
                validOnTuesday: false,
                validOnWednesday: false,
                validOnThursday: false,
                validOnFriday: false,
                validOnSaturday: false,
                validOnSunday: false,
                duration: null,
                maxOrders: null,
                maxValue: null
            }
        }

        this.changeState = this.changeState.bind(this);
        this.changeBooleanAttributeState = this.changeBooleanAttributeState.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        if (Object.keys(this.props.selectedPreparationTime).length) {
            this.setState({
                ...this.state,
                preparationTime: this.props.selectedPreparationTime
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedPreparationTime !== prevProps.selectedPreparationTime) {
            this.setState({
                ...this.state,
                preparationTime: this.props.selectedPreparationTime
            });
        }
    }

    componentWillUnmount() {
        this.setState({
            ...this.state,
            preparationTime: {
                id: null,
                fromHour: null,
                fromMinute: null,
                toHour: null,
                toMinute: null,
                validOnMonday: false,
                validOnTuesday: false,
                validOnWednesday: false,
                validOnThursday: false,
                validOnFriday: false,
                validOnSaturday: false,
                validOnSunday: false,
                duration: null,
                maxOrders: null,
                maxValue: null
            }
        });
    }

    submitForm() {
        const { validOnMonday, validOnTuesday, validOnWednesday, validOnThursday, validOnFriday, validOnSaturday, validOnSunday, duration, maxOrders, maxValue } = this.state.preparationTime;
        const isNoDaySelected = !validOnMonday && !validOnTuesday && !validOnWednesday && !validOnThursday && !validOnFriday && !validOnSaturday && !validOnSunday;
        const { timeSlotBased } = this.props;

        if (this.state.preparationTime.fromHour == null
            || this.state.preparationTime.toHour == null || this.state.preparationTime.fromMinute == null
            || this.state.preparationTime.toMinute == null || isNoDaySelected || (timeSlotBased && !duration)
            || (timeSlotBased && (!maxOrders && !maxValue))) {

            if (isNoDaySelected) {
                this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.noDaySelected'));
            } else {
                this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.emptyForm'));
            }
            return;
        }

        if (this.props.save(this.state.preparationTime)) {
            // Let the parent screen close this one if there are no errors
            // since the validation for overlapping preparation times is made there.
            // this.props.onToggle();
            // this.resetState();
            // console.log('SUCCESS');
        }
    }

    changeState({ target }) {
        if (
            target.name === 'fromHour' && Number(target.value) < 24 || 
            target.name === 'toHour' && Number(target.value) < 24  ||
            target.name === 'fromMinute' && Number(target.value) < 60 ||
            target.name === 'toMinute' && Number(target.value) < 60 || 
            target.name === 'duration' || target.name === 'maxOrders' ||
            target.name === 'maxValue'
        ) {
            this.setState({
                preparationTime: {
                    ...this.state.preparationTime,
                    [target.name]: target.value || target.value === 0 ? parseInt(target.value) : target.value
                }
            });
        } else {
            this.setState({
                preparationTime: {
                    ...this.state.preparationTime,
                    [target.name]: ''
                }
            });
        }
    }

    changeBooleanAttributeState({ target }) {
        const checked = convertStringToBoolean(target.checked);

        this.setState({
            preparationTime: {
                ...this.state.preparationTime,
                [target.name]: checked
            }
        });
    }

    render() {
        const isApplyDisabled = this.state.preparationTime.fromHour === '' || this.state.preparationTime.fromMinute === '' || this.state.preparationTime.toHour === '' || this.state.preparationTime.toMinute === '';

        return (
            <Modal className='operationTimeScreen' isOpen={this.props.isOpen} toggle={() => this.props.toggle(true)}>
                <AvForm>
                    <ModalHeader className="modalHeader" toggle={() => this.props.toggle(true)} style={{ margin: 'auto' }}>{i18n.t('screens:operationTimeScreen.modalHeader')}</ModalHeader>
                    <ModalBody>
                        <HeaderAndDays
                            timeSlotBased={this.props.timeSlotBased}
                            preparationTime={this.state.preparationTime}
                            isRequired={true}
                            changeState={this.changeState}
                            changeCheckBoxState={this.changeBooleanAttributeState} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.submitForm} disabled={isApplyDisabled}>
                            <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </Modal>
        );
    }
}

export default OperationTimeScreen;


// WEBPACK FOOTER //
// ./src/components/common/operationHours/OperationTimeScreen.js